import React from "react";
import styled from "styled-components";
import { FONTS, COLORS, BREAKPOINTS } from "../utils/styleConstants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 400px;
  text-align: center;
  padding: 0 2rem;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  color: ${(props) => (props.isError ? "#f44336" : "#4caf50")};
  margin-bottom: 1rem;
  font-family: ${FONTS.PRIMARY};
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  line-height: 1.5;
  font-family: ${FONTS.PRIMARY};
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const ModalTitle = styled.h3`
  margin-top: 0;
  font-size: 1.25rem;
  color: ${(props) => (props.isError ? "#f44336" : "#4caf50")};
  font-family: ${FONTS.PRIMARY};
`;

const ModalMessage = styled.p`
  color: #444;
  line-height: 1.5;
  font-family: ${FONTS.PRIMARY};
`;

const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
  gap: 1rem;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: ${FONTS.PRIMARY};
`;

const PrimaryButton = styled(Button)`
  background-color: ${(props) => (props.isError ? "#f44336" : "#4caf50")};
  color: white;
  border: none;

  &:hover {
    background-color: ${(props) => (props.isError ? "#d32f2f" : "#388e3c")};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px
      ${(props) =>
        props.isError ? "rgba(244, 67, 54, 0.5)" : "rgba(76, 175, 80, 0.5)"};
  }
`;

const NotificationMessage = ({
  title,
  message,
  isError = false,
  isModal = false,
  onClose,
}) => {
  if (isModal) {
    return (
      <ModalOverlay>
        <ModalContent>
          <ModalTitle isError={isError}>{title}</ModalTitle>
          <ModalMessage>{message}</ModalMessage>
          <ModalButtons>
            <PrimaryButton onClick={onClose} isError={isError}>
              Aceptar
            </PrimaryButton>
          </ModalButtons>
        </ModalContent>
      </ModalOverlay>
    );
  }

  return (
    <Container>
      <Title isError={isError}>{title}</Title>
      <Message>{message}</Message>
    </Container>
  );
};

export default NotificationMessage;
